/**
 * "276 claims hidden: they belong to terminated people … · Show them" — said wherever the Employee status
 * control is the only reason something asked for is not on screen.
 *
 * Picking someone who has left, by name or by search, used to show an empty table
 * with nothing saying why (2026-09-25, `PC110230`). The status control is in the
 * top bar, often scrolled away or hidden by "Choose filters", so the reason has to be
 * said where the empty result is.
 */
import { useFilters } from '@/data/filters'
import { int } from '@/format'

export function HiddenByStatus({ count, noun }: { count: number; noun: string }) {
  const { filters, set } = useFilters()
  if (count === 0 || filters.employmentStatus === 'both') return null
  const who = filters.employmentStatus === 'active' ? 'terminated' : 'active'
  return (
    <span style={{ color: 'var(--crit-ink)' }}>
      {int(count)} {noun} hidden: they belong to {who} people, and Employee status is{' '}
      {filters.employmentStatus === 'active' ? 'Active only' : 'Terminated only'}
      {' · '}
      <button
        type="button"
        onClick={() => set('employmentStatus', 'both')}
        style={{
          border: 0,
          background: 'none',
          padding: 0,
          font: 'inherit',
          color: 'var(--accent)',
          cursor: 'pointer',
          textDecoration: 'underline',
          textUnderlineOffset: 2,
        }}
      >
        Show them
      </button>
    </span>
  )
}
